import React from 'react';
import '../css/MainPageFooterStyling.css';
import {useNavigate} from "react-router-dom";

const MainPageFooter = () => {

    const navigate = useNavigate();

    return (
        <footer className="footer">
            <div className="container">
                <h3>Ready to Plant Your Garden?</h3>
                <p>Join countless gardeners who've transformed their outdoor spaces with Planted, all completely
                    free.</p>
                <div className={`main-page-footer-buttons`}>
                    <div onClick={() => navigate("/in-ground-layout-page")} className="cta-button">Get Started!</div>
                    <div onClick={() => navigate("/about")} className="cta-button">About Planted</div>
                </div>
            </div>
        </footer>
    )
}

export default MainPageFooter;